import { Statistics } from '../api/types/Insights';
import { getRiskIndicatorByRiskRule, RISK_CATEGORIES } from '@silverfort-nodelibs/common/utils/insight';

type IspmExposureByCategoryItem = {
    key: string;
    title: string;
    total: number;
};

const initiateCategoryAggregatedData = () => {
    return Object.values(RISK_CATEGORIES).reduce<Record<string, IspmExposureByCategoryItem>>((acc, category) => {
        acc[category.key] = { key: category.key, title: category.title, total: 0 };

        return acc;
    }, {});
};

export const aggregateExposuresByCategory = (
    insightsStatistics: Statistics | null | undefined,
    customInsightsIdsToNames: Record<string, string>
): Record<string, IspmExposureByCategoryItem> => {
    const data = initiateCategoryAggregatedData();

    if (!insightsStatistics) return data;

    Object.entries(insightsStatistics).forEach(([insightKey, entitiesCount]) => {
        const insightCategory =
            insightKey in customInsightsIdsToNames
                ? RISK_CATEGORIES.CUSTOM_INSIGHTS
                : getRiskIndicatorByRiskRule(insightKey)?.category;

        if (insightCategory && entitiesCount > 0) {
            data[insightCategory.key].total += entitiesCount;
        }
    });

    return data;
};
